import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=32bc1f40&scoped=true&"
import script from "./PageTitle.vue?vue&type=script&lang=js&"
export * from "./PageTitle.vue?vue&type=script&lang=js&"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=32bc1f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bc1f40",
  null
  
)

export default component.exports